<template>
  <v-dialog :value="show" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ customerTrackingId ? $t('Editar Seguimiento') : $t('Añadir Seguimiento') }}
        </span>
      </v-card-title>
      <v-card-text style="padding-top: 0">
        <template v-if="loaded">
          <v-form ref="customerTrackingForm">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs4>
                  <v-btn
                    style="width: 100%; margin: 0"
                    color="primary"
                    @click="$emit('on-show-freelance-guide')"
                  >
                    {{ $t('Guión autónomos') }}
                  </v-btn>
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    style="width: 100%; margin: 0"
                    color="primary"
                    @click="$emit('on-show-society-guide')"
                  >
                    {{ $t('Guión sociedades') }}
                  </v-btn>
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    style="width: 100%; margin: 0"
                    color="primary"
                    @click="$emit('on-show-laboral-guide')"
                  >
                    {{ $t('Guión laboral') }}
                  </v-btn>
                </v-flex>
                <v-flex xs12 v-if="!isConsultant">
                  <v-alert :value="'true'" color="red" outline>
                    {{ $t('No eres asesor/a y por tanto no puedes añadir/editar un seguimiento') }}
                  </v-alert>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="customerTrackingForm.clavedat"
                    :items="companiesList"
                    :label="$t('Empresa *')"
                    :rules="[rules.required]"
                    chips
                    @change="getContactsCompany"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="customerTrackingForm.customer_id"
                    :items="contactsCompanyList"
                    :label="$t('Contacto *')"
                    :rules="[rules.required]"
                    chips
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    v-model="customerTrackingForm.consultant_id"
                    :items="consultantList"
                    :label="$t('Asesor/a')"
                    :rules="[rules.required]"
                    chips
                    disabled
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox
                    v-model="customerTrackingForm.quality_protocol"
                    label="Protocolo calidad"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="customerTrackingForm.title"
                    :label="$t('Asunto *')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <!--<template v-if="customerTrackingId">
                  <v-flex xs12 sm4>
                    <v-select
                      v-model="customerTrackingForm.status"
                      :items="[
                        { text: 'Abierto', value: 'abierto' },
                        { text: 'Cerrado', value: 'cerrado' },
                      ]"
                      :label="$t('Estado *')"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-flex>
                </template>-->
                <v-flex xs4>
                  <v-select
                    v-model="customerTrackingForm.type"
                    :items="[
                      { text: 'Telefónico', value: 'telefonico' },
                      { text: 'Email', value: 'email' },
                      { text: 'Videollamada', value: 'videollamada' },
                      { text: 'Otros', value: 'otros' },
                    ]"
                    :label="$t('Tipo de contacto *')"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex xs4>
                  <v-menu
                    v-model="showTrackingFormDatePicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        ref="date"
                        v-model="formattedTrackingDate"
                        class="pr-2"
                        label="Fecha *"
                        readonly
                        v-on="on"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="customerTrackingForm.date"
                      @input="showTrackingFormDatePicker = false"
                      locale="es"
                      first-day-of-week="1"
                      :reactive="true"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox
                    v-model="customerTrackingForm.pending_actions"
                    label="Acción pendiente"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="customerTrackingForm.observations"
                    :label="$t('Observaciones')"
                    auto-grow
                    rows="4"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-flex>
                <template v-if="customerTrackingForm.id">
                  <v-flex
                    xs12
                    class="mt-5"
                    v-for="(item, index) in customerTrackingForm.notes"
                    :key="`${trackingNotesKey}-tracking-note-item-${index}`"
                  >
                    <customer-tracking-note
                      :index="index"
                      :tracking-note="item"
                      :consultant-list="consultantList"
                      @note-changed="onNoteChanged($event)"
                    ></customer-tracking-note>
                  </v-flex>
                  <v-flex xs12 class="mt-4">
                    <v-btn class="left" color="secondary" @click="addTrackingNote()">
                      <v-icon left>mdi-plus</v-icon>
                      {{ $t('AÑADIR NOTA') }}
                    </v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-form>
        </template>
        <template v-else>
          <v-flex xs12 class="text-xs-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-flex>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="creatingTracking" color="blue darken-1" flat @click="$emit('close')">
          {{ $t('Cerrar') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="creatingTracking || !isConsultant"
          @click="!customerTrackingId ? createTrackingForm() : updateTrackingForm()"
        >
          {{ $t('Guardar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';
import moment from 'moment';
import EmpresaAPI from '@/modules/admin/aplifisa/services/fiscal';
import ConsultantAPI from '@/modules/admin/customers-and-consultants/services/consultantAPI';

export default {
  name: 'CustomerTrackingForm',
  props: ['show', 'customerTrackingId'],
  components: { CustomerTrackingNote: () => import('./CustomerTrackingNote.vue') },
  data() {
    return {
      creatingTracking: false,
      showTrackingFormDatePicker: false,
      trackingNotesKey: 0,
      companiesList: [],
      contactsCompanyList: [],
      consultantList: [],
      customerTrackingForm: {
        id: null,
        consultant_id: null,
        customer_id: null,
        clavedat: null,
        title: null,
        type: null,
        date: null,
        observations: null,
        status: 'abierto',
        pending_actions: false,
        quality_protocol: false,
        notes: [
          {
            id: null,
            customer_tracking_id: null,
            note: null,
            date: null,
            consultant_id: null,
            pending_actions: false,
          },
        ],
      },
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
      },
    };
  },
  beforeMount() {
    this.getCompaniesList();
    this.getConsultantsList();
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.hasOwnProperty('consultant_profile') && user.consultant_profile !== null) {
      this.customerTrackingForm.consultant_id = user.consultant_profile['id'];
    }
    if (this.customerTrackingId) {
      this.fetchCustomerTracking();
    }
  },
  computed: {
    formattedTrackingDate() {
      return this.customerTrackingForm.date
        ? moment(this.customerTrackingForm.date).format('DD/MM/YYYY')
        : '';
    },
    isConsultant() {
      return !!this.customerTrackingForm.consultant_id;
    },
    loaded() {
      if (this.customerTrackingId) {
        return (
          this.companiesList.length > 0 &&
          this.contactsCompanyList.length > 0 &&
          this.consultantList.length > 0
        );
      } else {
        return this.companiesList.length > 0 && this.consultantList.length > 0;
      }
    },
  },
  methods: {
    onNoteChanged($event) {
      this.customerTrackingForm.notes[$event.index] = $event.note;
    },
    addTrackingNote() {
      let consultantId = null;
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.hasOwnProperty('consultant_profile') && user.consultant_profile !== null) {
        consultantId = user.consultant_profile['id'];
      }
      const trackingNote = {
        id: null,
        customer_tracking_id: this.customerTrackingForm.id,
        note: null,
        date: moment().format('YYYY-MM-DD'),
        consultant_id: consultantId,
        pending_actions: false,
      };
      this.customerTrackingForm.notes.push(trackingNote);
      this.trackingNotesKey++;
    },
    getCompaniesList() {
      EmpresaAPI.getFiscalDataInputSelect().then(response => {
        this.companiesList = response.data;
      });
    },
    getConsultantsList() {
      ConsultantAPI.getConsultantInputSelect().then(response => {
        this.consultantList = response.data;
      });
    },
    getContactsCompany() {
      this.customerTrackingForm.customer_id = null;
      if (this.customerTrackingForm.clavedat) {
        EmpresaAPI.getContactsOfCompany(this.customerTrackingForm.clavedat).then(response => {
          this.contactsCompanyList = response.data.data;
        });
      } else {
        this.contactsCompanyList = [];
      }
    },
    fetchCustomerTracking() {
      apiCtrl.get(`/admin/customer-tracking/show/${this.customerTrackingId}`).then(res => {
        this.customerTrackingForm = res.data;
        EmpresaAPI.getContactsOfCompany(this.customerTrackingForm.clavedat).then(response => {
          this.contactsCompanyList = response.data.data;
        });
      });
    },
    createTrackingForm() {
      this.creatingTracking = true;
      let validateFields = [];
      this.$refs.customerTrackingForm.validate();
      Object.keys(this.customerTrackingForm).forEach(f => {
        if (this.$refs[f]) {
          const validated = this.$refs[f].validate(true);
          validateFields.push(validated);
        }
      });
      if (validateFields.every(validated => validated === true)) {
        apiCtrl
          .post('/admin/customer-tracking/create', this.customerTrackingForm)
          .then(res => {
            this.$emit('on-saved-tracking', res.data.data);
          })
          .catch(err => console.log(err));
      }
      this.creatingTracking = false;
    },
    updateTrackingForm() {
      this.creatingTracking = true;
      let validateFields = [];
      this.$refs.customerTrackingForm.validate();
      Object.keys(this.customerTrackingForm).forEach(f => {
        if (this.$refs[f]) {
          const validated = this.$refs[f].validate(true);
          validateFields.push(validated);
        }
      });
      // Validate notes
      let validateNotes = [];
      this.customerTrackingForm.notes.forEach(note => {
        if (note.note && note.date && note.consultant_id) {
          validateNotes.push(true);
        } else {
          validateNotes.push(false);
        }
      });
      if (
        validateFields.every(validated => validated === true) &&
        validateNotes.every(validated => validated === true)
      ) {
        apiCtrl
          .post(
            `/admin/customer-tracking/update/${this.customerTrackingId}`,
            this.customerTrackingForm,
          )
          .then(res => {
            this.$emit('on-saved-tracking', res.data.data);
          })
          .catch(err => console.log(err));
      }
      this.creatingTracking = false;
    },
  },
};
</script>

<style scoped></style>
